import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(
    private readonly http: HttpClient,
  ) {
    
   }

   getCompanyStockDetails(payload:any,filters:any): Observable<any>{
      let url = environment.BASE_URL + '/v1/company-stock';
      return this.http.post(url, payload,{params :filters});
    }

    exportTyreStock(){
      let url = environment.BASE_URL + '/v1/company-stock/tyre-stats-export';
      return this.http.post(url,{},
        { responseType: 'blob', observe: 'response' });
    } 
}
